export default __webpack_public_path__ + "664bd6f78690cab3e4ce115b09d73ce0.png";